var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-table",
        {
          ref: "stationDailyDiffData" + _vm.stationId,
          staticStyle: { width: "100%" },
          attrs: {
            id: "stationDailyDiffData" + _vm.stationId,
            data: _vm.stationDailyDiffData,
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "sum-text": "合计",
            "highlight-current-row": "",
            border: "",
            height: "740"
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              label: "日期",
              width: "100px",
              align: "center",
              prop: "reportDate"
            }
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                label: _vm.sellerName + "月度报表差异表",
                "header-align": "center"
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { label: "站点销售", "header-align": "center" } },
                [
                  _c(
                    "el-table-column",
                    { attrs: { label: "0# 柴油", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "diesel0Nums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "diesel0Amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "92# 汽油", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "petrol92Nums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "petrol92Amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "95# 汽油", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "petrol95Nums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "petrol95Amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "油机应收", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "oilNums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "oilAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "回罐", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "oilReturnNums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "oilReturnAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "油机异常", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "oilWarnNums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "oilWarnAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "油机实收", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "oilSaleNums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "oilSaleAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "充值", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "卡充值",
                          width: "100px",
                          align: "center",
                          prop: "chargeAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "钱包充值",
                          width: "100px",
                          align: "center",
                          prop: "walletChargeAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "其他", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "地磅计费",
                          align: "center",
                          prop: "loadometerAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "补卡",
                          align: "center",
                          prop: "lossCardAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "便利店", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "营业额",
                          width: "100px",
                          align: "center",
                          prop: "shopAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "优惠", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "营销优惠",
                          width: "100px",
                          align: "center",
                          prop: "selfDiscount"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.xwlCapitalDiscount
                                        ? scope.row.selfDiscount -
                                            scope.row.xwlCapitalDiscount
                                        : scope.row.selfDiscount
                                    ) +
                                    " "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "新文旅出资",
                          width: "100px",
                          align: "center",
                          prop: "xwlCapitalDiscount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "平台优惠",
                          width: "100px",
                          align: "center",
                          prop: "platDiscount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "支付优惠",
                          width: "100px",
                          align: "center",
                          prop: "tradeDiscount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table-column",
                { attrs: { "header-align": "center", label: "实收款" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "转账",
                      align: "center",
                      width: "100px",
                      prop: "transferAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "卡消费",
                      width: "100px",
                      align: "center",
                      prop: "svcAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "授权卡",
                      align: "center",
                      prop: "creditAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "记账卡",
                      align: "center",
                      prop: "accountAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "电子钱包",
                      width: "100px",
                      align: "center",
                      prop: "walletAmount"
                    }
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: { label: "通联", width: "100px", align: "center" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "POS机",
                          width: "100px",
                          align: "center",
                          prop: "posAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "合计",
                          width: "100px",
                          align: "center",
                          prop: "onlineAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "（户）",
                          width: "120px",
                          align: "center",
                          prop: "onlineHuAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "（个）",
                          width: "120px",
                          align: "center",
                          prop: "onlineGeAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "拉卡拉",
                        width: "100px",
                        align: "center"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "POS机",
                          width: "100px",
                          align: "center",
                          prop: "lklPosAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "合计",
                          width: "100px",
                          align: "center",
                          prop: "lklOnlineAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "（户）",
                          width: "120px",
                          align: "center",
                          prop: "lklOnlineHuAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "（个）",
                          width: "120px",
                          align: "center",
                          prop: "lklOnlineGeAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: { label: "富友", width: "100px", align: "center" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "POS机",
                          width: "100px",
                          align: "center",
                          prop: "fyPosAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "合计",
                          width: "100px",
                          align: "center",
                          prop: "fyOnlineAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "（户）",
                          width: "120px",
                          align: "center",
                          prop: "fyOnlineHuAmount"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "（个）",
                          width: "120px",
                          align: "center",
                          prop: "fyOnlineGeAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: { label: "星驿", width: "100px", align: "center" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "POS机",
                          width: "100px",
                          align: "center",
                          prop: "xyPosAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-table-column", {
                    attrs: {
                      label: "滴滴",
                      width: "100px",
                      align: "center",
                      prop: "plat2001Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "小象",
                      width: "100px",
                      align: "center",
                      prop: "plat2005Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "团油",
                      width: "100px",
                      align: "center",
                      prop: "plat2004Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "货车帮",
                      width: "100px",
                      align: "center",
                      prop: "plat2002Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "易加油",
                      width: "100px",
                      align: "center",
                      prop: "plat2003Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "货拉拉",
                      width: "100px",
                      align: "center",
                      prop: "plat2010Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "佰思达",
                      width: "100px",
                      align: "center",
                      prop: "plat2011Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "爱车平台",
                      width: "100px",
                      align: "center",
                      prop: "plat2012Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "团油车队",
                      width: "100px",
                      align: "center",
                      prop: "plat2013Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "鲸车惠",
                      width: "100px",
                      align: "center",
                      prop: "plat2014Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "途虎",
                      width: "100px",
                      align: "center",
                      prop: "plat2009Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "喂车车",
                      width: "100px",
                      align: "center",
                      prop: "plat2008Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "嗨卡",
                      width: "100px",
                      align: "center",
                      prop: "plat2007Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "刷脸付",
                      width: "100px",
                      align: "center",
                      prop: "plat1008Amount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "其他",
                      width: "100px",
                      align: "center",
                      prop: "otherAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "现金",
                      width: "100px",
                      align: "center",
                      prop: "cashAmount"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "合计",
                      width: "120px",
                      align: "center",
                      prop: "totalReceivableAmount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-table-column",
                { attrs: { "header-align": "center", label: "差异情况" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      "header-align": "center",
                      width: "120px",
                      label: "差异金额",
                      prop: "totalDiff"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.dailyInfoStatus === 0
                              ? _c(
                                  "el-tag",
                                  { attrs: { size: "mini", type: "warning" } },
                                  [_vm._v("未录入")]
                                )
                              : scope.row.dailyInfoStatus > 0 &&
                                scope.row.totalDiff > 0
                              ? _c(
                                  "el-tag",
                                  { attrs: { size: "mini", type: "success" } },
                                  [_vm._v(_vm._s(scope.row.totalDiff))]
                                )
                              : scope.row.dailyInfoStatus > 0 &&
                                scope.row.totalDiff === 0
                              ? _c(
                                  "el-tag",
                                  { attrs: { size: "mini", type: "info" } },
                                  [_vm._v(_vm._s(scope.row.totalDiff))]
                                )
                              : scope.row.dailyInfoStatus > 0 &&
                                scope.row.totalDiff < 0
                              ? _c(
                                  "el-tag",
                                  { attrs: { size: "mini", type: "danger" } },
                                  [_vm._v(_vm._s(scope.row.totalDiff))]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "header-align": "center",
                      width: "200px",
                      label: "备注说明",
                      prop: "remark",
                      "show-overflow-tooltip": true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-table-column",
                { attrs: { "header-align": "center", label: "存行" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "金额",
                      align: "center",
                      width: "100px",
                      prop: "dailyCashDeposit.depositValue"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "未存",
                      align: "center",
                      width: "100px",
                      prop: "dailyCashDeposit.depositLeftValue"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "凭证",
                      align: "center",
                      width: "100px",
                      "show-overflow-tooltip": true
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.dailyCashDeposit.depositSlip === ""
                              ? _c(
                                  "el-tag",
                                  { attrs: { size: "mini", type: "warning" } },
                                  [_vm._v("未上传")]
                                )
                              : _vm._e(),
                            scope.row.dailyCashDeposit.depositSlip !== ""
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      href:
                                        scope.row.dailyCashDeposit.depositSlip,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.dailyCashDeposit.depositSlip
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "el-table-column",
                { attrs: { "header-align": "center", label: "储值余额情况" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "已迁移卡余额",
                      width: "100px",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [_vm._v(_vm._s(scope.row.svcTotalLeft))]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "未迁移卡余额",
                      width: "100px",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [_vm._v(_vm._s(scope.row.sanSvcTotalLeft))]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "电子钱包本金余额",
                      width: "100px",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(_vm._s(scope.row.walletRechargeTotalLeft))
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "电子钱包赠送余额",
                      align: "center",
                      width: "100px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [_vm._v(_vm._s(scope.row.walletGiveTotalLeft))]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }